import {Response, SuperAgentRequest} from "superagent";
import request from '../../util/SuperagentUtils';
import {paymentEndpoints} from "../../requests/api-endpoints";

const handleFailure = (response: Response): Response => {
  if (!response.ok) {
    // superagent's typings omit statusText, though the browser client's Response sets it.
    const {status, statusText} = response as Response & {statusText?: string};
    throw Error(`${status} - ${statusText}`);
  }
  return response;
}

export function requestGetFailedTransactionsForBooking(
    bookingId: string,
    onSuccess: (body: unknown) => void,
    onFail: (err: unknown) => void
): void;
export function requestGetFailedTransactionsForBooking(bookingId: string): SuperAgentRequest;
export function requestGetFailedTransactionsForBooking(
    bookingId: string,
    onSuccess?: (body: unknown) => void,
    onFail?: (err: unknown) => void
): void | SuperAgentRequest {
    const result = request
        .get(paymentEndpoints.getFailedPaymentsForBooking(bookingId))

    if(onSuccess && onFail) {
        result
            .then((resp) => onSuccess(resp.body))
            .catch((err: unknown) => onFail(err))
    } else {
        return result
    }
}

export const requestBookingById = async (bookingId: string) => {
  return handleFailure(await request.get(paymentEndpoints.getBookingById(bookingId)))
}

export const getFailedBookingTransactionFees = (bookingId: string, paymentMethodId: string, bookingTransactionIds?: string[]) => {
  const searchParams = new URLSearchParams();
  searchParams.append('bookingId', bookingId);
  searchParams.append('paymentMethodId', paymentMethodId);
  if (bookingTransactionIds) searchParams.append('transactionIds', bookingTransactionIds.join(','));
  return request.get(`${paymentEndpoints.bookingTransactionFeeSummary}?${searchParams.toString()}`);
}
